<div class="page-overlay"
     role="alertdialog"
     aria-modal="true"
     aria-labelledby="dialog-title dialog-subtitle"
     aria-live="polite"
     ohpFocusContext
     startId="close-dialog-overlay"
     [endId]="lastFocusedElementId || 'close-dialog-overlay'">
    <div class="page-overlay__background ms-bgc-nd"></div>
    <div class="dialog ms-bgc-w">
        <button id="close-dialog-overlay"
                class="dialog__dismiss-x ms-fcl-nd"
                [attr.aria-label]="dismissAriaLabel"
                [attr.data-area]="componentArea"
                (click)="onDismissClick()"
                #closeLink>
            <ohp-icon-font iconFontName="X2" size="14"></ohp-icon-font>
        </button>
        <h2 *ngIf="title" id="dialog-title" class="dialog__title--fluent ms-fcl-ns">{{ title }}</h2>
        <div *ngIf="subtitle || content" class="dialog__content-container ms-fcl-nd">
            <div *ngIf="subtitle" class="dialog-subtitle ms-fcl-ns">{{ subtitle }}</div>
            <div *ngIf="content" class="dialog-content ms-fcl-ns">{{ content }}</div>
        </div>
        <div *ngIf="dismissButtonEnabled" class="dialog__dismiss-button">
            <button id="dialog-dismiss-button"
                    class="generic-button ms-bgc-tp ms-fcl-w generic-button--fluent generic-button--fluent--primary generic-button--bordered ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a"
                    (click)="onDismissClick()"
                    [attr.data-area]="componentArea"
                    [attr.aria-label]="dismissAriaLabel">
                <span class="generic-button__text">{{ dismissText }}</span>
            </button>
        </div>
        <div class="dialog__actions">
            <ng-content select="[ohpDialogActions]"></ng-content>
        </div>
        <div class = "dialog__footer">
            <ng-content select="[ohpDialogFooter]"></ng-content>
        </div>
    </div>
</div>
